import ListErrors from '../components/ListErrors'
import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import {
    VERIFY_USER_PIN,
    VERIFY_PIN_CODE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    currentUser: state.common.currentUser,
    errors: state.common.errors,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onCheckPinCode: (payload) => {
        dispatch({ type: VERIFY_USER_PIN, payload })
    },
    onUnload: () =>
        dispatch({ type: VERIFY_PIN_CODE_UNLOADED })
})

class VerifiyPin extends React.Component {
    constructor() {
        super()
        this.state = {
            code: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.checkPinCode = (code) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.verifyUserPin(this.props.currentUser.token, this.props.currentUser.key, code);
            this.props.onCheckPinCode(payload)
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const code = this.state.code || ''
        return (
            <div id="focus">
                <div id="main">
                    <div id="main-wrap">
                        <div id="focus-wrap">
                            <h2>Verification Code</h2>
                            <div className="FormItem">
                                <label>PIN Code</label>
                                <input type="password" maxLength={4} value={code} onChange={this.updateState('code')} />
                            </div>
                            <ListErrors errors={this.props.errors} />
                            <div className="FormItem">
                                <button onClick={this.checkPinCode(code)}>{this.props.inProgress ? 'Login...' : 'Login'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifiyPin)
